import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CreditCardIcon from '../../../../../../icons/CreditCardIcon';
import DesignEditorPrimaryControlButton from '../../../../../DesignEditor/components/DesignEditorControls/components/DesignEditorPrimaryControlButton';

const propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

const CardDesignerIDCardElementControlsButton = ({
  className,
  active,
  onClick,
}) => {
  const classes = classNames({
    [className]: !!className,
  });

  return (
    <DesignEditorPrimaryControlButton
      className={classes}
      active={active}
      icon={<CreditCardIcon />}
      title="Elements"
      onClick={onClick}
    />
  );
};

CardDesignerIDCardElementControlsButton.propTypes = propTypes;

export default CardDesignerIDCardElementControlsButton;
